<template>
  <div class="step2">
    <h2 class="access_hidden">전환금액 입력</h2>
    <exchange-point-info />
    <exchange-point @btnState="btnState" />
    <exchange-notice />
    <div class="bt">
      <v-button @handleClick="handleClick" class="btn01" text="다음" :disabled="btnDisabled" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ExchangePointInfo from '@/components/modules/exchange/ExchangePointInfo';
import ExchangePoint from '@/components/modules/exchange/ExchangePoint';
import ExchangeNotice from '@/components/modules/exchange/ExchangeNotice';
import VButton from '@/components/atoms/VButton';
import { pointErrorMsg } from '@/utils/errorMsg';
import eventBus from '@/utils/eventBus';
import { selectOpenModal } from '@/utils';

export default {
  components: {
    ExchangePointInfo,
    ExchangePoint,
    ExchangeNotice,
    VButton,
  },
  data() {
    return {
      btnDisabled: true,
    };
  },
  computed: {
    ...mapGetters(['isExchangeIframe']),
    ...mapGetters('exchange', ['exchangeRequest']),
  },
  created() {
    if (this.$route.params.serviceUrl) {
      this.setServiceUrl(this.$route.params.serviceUrl);
    }
    eventBus.$emit('scrollUpdate');
  },
  beforeDestroy() {
    eventBus.$emit('scrollTop');
  },
  methods: {
    ...mapActions(['setServiceUrl']),
    ...mapActions('exchange', ['getBankList', 'getExchangeInit', 'setExchangeStep']),
    async handleClick() {
      if (!this.btnDisabled) {
        await this.getBankList();
        const apiReturn = await this.getExchangeInit(this.exchangeRequest.point);
        if (apiReturn === 0) {
          this.setExchangeStep('step3');
          this.$router.replace({ name: 'Step3' });
        } else if (apiReturn !== 2) {
          selectOpenModal(pointErrorMsg(apiReturn.code));
        }
      }
    },
    btnState(val) {
      this.btnDisabled = val;
    },
  },
};
</script>
